import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "toggleable", "button" ]

  toggleText(e) {
    e.preventDefault();
    const toggledText = this.toggleableTarget
    toggledText.classList.toggle('hidden');
    if (toggledText.classList.contains('hidden')) {
      this.buttonTarget.textContent = this.data.get('open');
    } else {
      this.buttonTarget.textContent = this.data.get('close');
    }
  }

  connect() {
  }
}
